module.exports = __webpack_public_path__ + "img/204.68a2414c.png";